import { render } from "./RequestDetails.vue?vue&type=template&id=1e605d0e&scoped=true"
import script from "./RequestDetails.vue?vue&type=script&lang=js"
export * from "./RequestDetails.vue?vue&type=script&lang=js"

import "./RequestDetails.vue?vue&type=style&index=0&id=1e605d0e&scoped=true&lang=css"

import exportComponent from "/kaam/build/sicpa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e605d0e"]])

export default __exports__